import type { BlockProps } from '../../lib/card';
import { CardLayout } from '../../lib/card';
import { SourceLink } from '../components';
import { usePost } from '../Post';
import { usePostSettings } from '../utils';

interface CardSourceBlockProps extends BlockProps {
  centered?: boolean;
}

export function CardSourceBlock({
  centered,
  ...forwardingProps
}: CardSourceBlockProps) {
  const { url } = usePost();
  const { source: sourceSettings } = usePostSettings();

  if (!sourceSettings.show) {
    return null;
  }

  return (
    <CardLayout.Block {...forwardingProps} _center={centered}>
      <SourceLink {...sourceSettings} url={url} />
    </CardLayout.Block>
  );
}
